// React imports.
import React, { Component } from "react";

// App imports.
import Assessment4DownloadCSV from "./Assessment4DownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment4StepsEnum } from "../state";
import { Assessment4Model } from "../state";

const Assessment4 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q1TrackAcctNoFormat &&
          <div>
              <p><strong><u>Question 1:</u>&nbsp;&nbsp;Checking Routines for Household Account Number Format</strong></p>
              <ol start={1}>
                  {/*trackAcctNoFormat*/}
                  <li>
                        Do you have a check in place for verifying that account numbers for each vendor follow the correct account number format?
                        <br/>
                        <label>
                            <input type="radio"
                                name="trackAcctNoFormatFlag"
                                id="trackAcctNoFormatFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.trackAcctNoFormatFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackAcctNoFormatFlag"
                                id="trackAcctNoFormatFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.trackAcctNoFormatFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackAcctNoFormatFlag"
                                id="trackAcctNoFormatFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.trackAcctNoFormatFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.trackAcctNoFormatFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>   
                              It is common for utility companies to use a standard format for their account numbers. For example, the account numbers might all contain a precise number of digits or may contain letters at certain points within the number. Checking that all account numbers follow the correct format for each vendor is a quick and efficient way to determine if there is a large number of bad account numbers in a batch of data.
                            </span>
                          }
                        {state.Assessment4ModelInstance.trackAcctNoFormatFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              It is common for utility companies to use a standard format for their account numbers. For example, the account numbers might all contain a precise number of digits or may contain letters at certain points within the number. Checking that all account numbers follow the correct format for each vendor is a quick and efficient way to determine if there is a large number of bad account numbers in a batch of data.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="trackAcctNoFormatDesc"
                                  id="trackAcctNoFormatDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackAcctNoFormatDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}

                        {state.Assessment4ModelInstance.trackAcctNoFormatFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you have a check in place to verify that account numbers follow the correct account number format for each vendor in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="trackAcctNoFormatDesc"
                                  id="trackAcctNoFormatDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackAcctNoFormatDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q2TrackPercentAccountNo &&
          <div>
              <p><strong><u>Question 2:</u>&nbsp;&nbsp;Checking Routines for Household Account Numbers</strong></p>
              <ol start={2}>
                  {/*trackPctHHAcctNo*/}
                  <li>
                        Do you have a check in place for tracking the percentage of your assisted households that have an electric vendor and account number listed in their file? 
                        <br/>
                        <label>
                            <input type="radio"
                                name="trackPctHHAcctNoFlag"
                                id="trackPctHHAcctNoFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackPctHHAcctNoFlag"
                                id="trackPctHHAcctNoFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackPctHHAcctNoFlag"
                                id="trackPctHHAcctNoFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>
                              This will help you assess which vendors should be selected for data collection. It will also help you track what percentage of the total households a vendor serves are provided when they deliver the data each year.
                            </span>
                          }

                        {state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Accurate vendor names and account numbers are not only required for Performance Measures data collection, but also for ensuring that the correct customer account is credited with the LIHEAP grant. It is a "best practice" to ask vendors to report households for whom the account number is not correct, and to ensure that the client database is updated when the correct account number is retrieved. Furthermore, Tracking the number of assisted households that are missing an electric vendor or account number by agency and vendor can help you determine if there is a unique issue with one or more of your agencies or vendors that is preventing you from properly obtaining each client's electric vendor and account number.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="trackPctHHAcctNoDesc"
                                  id="trackPctHHAcctNoDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackPctHHAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}

                        {state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you have a check in place to track the percentage of assisted households with a vendor and account number on file in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="trackPctHHAcctNoDesc"
                                  id="trackPctHHAcctNoDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackPctHHAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
              {state.Assessment4ModelInstance.trackPctHHAcctNoFlag === "Y"
                && <ol className={'lowercaseList'} start={2}>
                      {/*trackMissingAcctNoCertainAgencies*/}
                      <li>
                            If you find that the rate of households that are missing a vendor or account number is high, do you have procedures in place for tracking whether the issue stems from certain vendors or agencies?
                            <br/>
                            <label>
                                <input type="radio"
                                    name="trackMissingAcctNoCertainAgenciesFlag"
                                    id="trackMissingAcctNoCertainAgenciesFlag_true"
                                    value="Y"
                                    checked={state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "Y"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>Yes</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="trackMissingAcctNoCertainAgenciesFlag"
                                    id="trackMissingAcctNoCertainAgenciesFlag_false"
                                    value="N"
                                    checked={state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "N"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>No</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="trackMissingAcctNoCertainAgenciesFlag"
                                    id="trackMissingAcctNoCertainAgenciesFlag_dk"
                                    value="U"
                                    checked={state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "U"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>Don't Know</span>
                            </label>
                            <br/ >
                            {state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "Y"
                              && <span>
                                  <strong>Good!  </strong>
                                  This will help you determine if there is a unique issue with one or more of your agencies that is preventing you from properly obtaining each client's electric vendor and account number.
                                </span>
                              }

                            {state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "N"
                              &&
                                <span>
                                  <strong>Requires followup.</strong>&nbsp;
                                  Accurate vendor names and account numbers are not only required for Performance Measures data collection, but also for ensuring that the correct customer account is credited with the LIHEAP grant. Tracking the number of assisted households that are missing an electric vendor or account number by agency and vendor can help you determine if there is a unique issue with one or more of your agencies or vendors that is preventing you from properly obtaining each client's electric vendor and account number. 
                                  <br/><br/>
                                  Please indicate your plans to address this issue in the box below
                                  <textarea  name="trackMissingAcctNoCertainAgenciesDesc"
                                      id="trackMissingAcctNoCertainAgenciesDesc" style={{width:"100%"}}
                                      value={state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesDesc}
                                      onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                                </span>}

                            {state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesFlag === "U"
                              &&
                                <span>
                                  <strong>Requires followup.</strong>&nbsp;
                                  You must determine whether you have a check in place to track the percentage of assisted households with a vendor and account number on file by agency and vendor in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                                  <br/><br/>
                                  Please indicate your plans for obtaining this information in the box below.
                                  <textarea  name="trackMissingAcctNoCertainAgenciesDesc"
                                      id="trackMissingAcctNoCertainAgenciesDesc" style={{width:"100%"}}
                                      value={state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesDesc}
                                      onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                                </span>}
                            <br/><br/>
                        </li>
                  
              </ol>}
          </div>
          }

          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q3TractPercentVendorNotFind &&
          <div>
              <p><strong><u>Question 3:</u>&nbsp;&nbsp;Checking Routines for Missing Information in the Vendor System</strong></p>
              <ol start={3}>
                  {/*trackPctHHVendorNotFind*/}
                  <li>
                        After you have requested Electric Baseload data, do you have a check in place for tracking
                        the percentage of your assisted households for whom vendors cannot find accounts in the
                        vendor system? 
                        <br/>
                        <label>
                            <input type="radio"
                                name="trackPctHHVendorNotFindFlag"
                                id="trackPctHHVendorNotFindFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackPctHHVendorNotFindFlag"
                                id="trackPctHHVendorNotFindFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackPctHHVendorNotFindFlag"
                                id="trackPctHHVendorNotFindFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>
                              This will help you assess which households are missing account information and will also help you recognize whether this issue is prevalent among just one vendor, or is related to a larger issue, such as a faulty vendor system or client application.
                            </span>
                          }
                        {state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup. </strong>&nbsp;
                              Tracking the percentage of households for whom vendors cannot find account information in the vendor system is critical to identifying the households for whom this is an issue. Furthermore, tracking these statistics by vendor and agency will also help you identify whether the issue is prevalent among just one vendor, or is related to a larger issue, such as a problem with your client application or vendor system.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="trackPctHHVendorNotFindDesc"
                                  id="trackPctHHVendorNotFindDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackPctHHVendorNotFindDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you have a check in place to track the percentage of assisted households for whom vendors cannot find accounts in the vendor system in order to complete a full assessment. Your IT staff may be able to provide you with this information, but you may need to contact your vendors.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="trackPctHHVendorNotFindDesc"
                                  id="trackPctHHVendorNotFindDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackPctHHVendorNotFindDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
              {state.Assessment4ModelInstance.trackPctHHVendorNotFindFlag === "Y"
                  &&<ol className={'lowercaseList'} start={2}>
                      {/*trackNotFindCertainAgencies*/}
                      <li>
                            If you find that the rate of households whom vendors cannot find in their vendor system is high, do you have procedures in place for tracking whether the issue stems from certain vendors or agencies?
                            <br/>
                            <label>
                                <input type="radio"
                                    name="trackNotFindCertainAgenciesFlag"
                                    id="trackNotFindCertainAgenciesFlag_true"
                                    value="Y"
                                    checked={state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "Y"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>Yes</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="trackNotFindCertainAgenciesFlag"
                                    id="trackNotFindCertainAgenciesFlag_false"
                                    value="N"
                                    checked={state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "N"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>No</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="trackNotFindCertainAgenciesFlag"
                                    id="trackNotFindCertainAgenciesFlag_dk"
                                    value="U"
                                    checked={state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "U"}
                                    onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                                />
                                <span>Don't Know</span>
                            </label>
                            <br/ >
                            {state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "Y"
                              && <span>
                                  <strong>Good!  </strong>
                                  This will help you determine if there is a unique issue with one or more of your agencies that is preventing your vendors from properly identifying each assisted household. 
                                </span>
                              }
                            {state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "N"
                              &&
                                <span>
                                  <strong>Requires followup. </strong>&nbsp;
                                  Accurate vendor names and account numbers are not only required for Performance Measures data collection, but also for ensuring that the correct customer account is credited with the LIHEAP grant. Tracking the number of assisted households that are missing an electric vendor or account number by agency and vendor can help you determine if there is a unique issue with one or more of your agencies or vendors that is preventing your vendors from properly identifying each assisted household.
                                  <br/><br/>
                                  Please indicate your plans to address this issue in the box below
                                  <textarea  name="trackNotFindCertainAgenciesDesc"
                                      id="trackNotFindCertainAgenciesDesc" style={{width:"100%"}}
                                      value={state.Assessment4ModelInstance.trackNotFindCertainAgenciesDesc}
                                      onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                                </span>}
                            {state.Assessment4ModelInstance.trackNotFindCertainAgenciesFlag === "U"
                              &&
                                <span>
                                  <strong>Requires followup.</strong>&nbsp;
                                  You must determine whether you have a check in place to track the percentage of assisted households with a vendor and account number on file by agency and vendor in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                                  <br/><br/>
                                  Please indicate your plans for obtaining this information in the box below.
                                  <textarea  name="trackNotFindCertainAgenciesDesc"
                                      id="trackNotFindCertainAgenciesDesc" style={{width:"100%"}}
                                      value={state.Assessment4ModelInstance.trackNotFindCertainAgenciesDesc}
                                      onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                                </span>}
                            <br/><br/>
                        </li>          
                  </ol>
              }
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q4IdLargestVendors &&
          <div>
              <p><strong><u>Question 4:</u>&nbsp;&nbsp;Identifying the Largest Vendors</strong></p>
              <ol start={4}>
                  {/*processIdentifyLargestElectricVendors*/}
                  <li>
                        To do performance measures, you have to have a procedure in place to identify the electric companies that serve the largest number of electric main heat clients in your state. Do you have a process for identifying the electric vendors in your state who serve the largest number of clients with baseload electric?
                        <br/>
                        <label>
                            <input type="radio"
                                name="processIdentifyLargestElectricVendorsFlag"
                                id="processIdentifyLargestElectricVendorsFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processIdentifyLargestElectricVendorsFlag"
                                id="processIdentifyLargestElectricVendorsFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processIdentifyLargestElectricVendorsFlag"
                                id="processIdentifyLargestElectricVendorsFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Tracking the vendors who serve the largest numbers of clients will help you ensure that you request and receive data from enough electric vendors. Without this information, you may not be able to request electric data from vendors representing enough clients to ensure data reliability.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="processIdentifyLargestElectricVendorsDesc"
                                  id="processIdentifyLargestElectricVendorsDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you have a process for identifying the vendors serving the most LIHEAP clients in order to complete a full assessment. Your IT staff or other staff members may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="processIdentifyLargestElectricVendorsDesc"
                                  id="processIdentifyLargestElectricVendorsDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
              {state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsFlag === "Y"
                && <ol className={'lowercaseList'} start={2}>
                  {/*processChooseVendorsBaseDiffHeat*/}
                  <li>
                        Do you have a process for choosing vendors if the largest main heating suppliers are different than the largest baseload suppliers?
                        <br/>
                        <label>
                            <input type="radio"
                                name="processChooseVendorsBaseDiffHeatFlag"
                                id="processChooseVendorsBaseDiffHeatFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processChooseVendorsBaseDiffHeatFlag"
                                id="processChooseVendorsBaseDiffHeatFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processChooseVendorsBaseDiffHeatFlag"
                                id="processChooseVendorsBaseDiffHeatFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>
                              This will help you assess whether you are collecting data for enough households to be representative of the entire population of assisted households with each fuel type. Since vendors that supply data should be able to furnish complete records for at least 75% of the LIHEAP households that they serve, make sure you're requesting from enough firms to ensure you will receive data from firms representing at least two thirds of LIHEAP clients.
                            </span>
                          }
                        {state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup. </strong>&nbsp;
                              If you don't use your identifications to determine from which vendors to request data, then the identification cannot assist you in ensuring data quality. Since vendors that supply data should be able to furnish complete records for at least 75% of the LIHEAP households that they serve, make sure you're requesting from enough firms to ensure you will receive data from firms representing at least two thirds of LIHEAP clients.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="processChooseVendorsBaseDiffHeatDesc"
                                  id="processChooseVendorsBaseDiffHeatDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you use this vendor-identification to secure reliable data on LIHEAP client electric costs  in order to complete a full assessment. Your staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="processChooseVendorsBaseDiffHeatDesc"
                                  id="processChooseVendorsBaseDiffHeatDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
              }
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q5TrackVendorCompliance &&
          <div>
              <p><strong><u>Question 5:</u>&nbsp;&nbsp;Data Checking Routines</strong></p>
              <ol start={5}>
                  {/*processTrackVendorCompliance*/}
                  <li>
                        Do you have a process for tracking whether electric vendors have supplied data in the past when requested?
                        <br/>
                        <label>
                            <input type="radio"
                                name="processTrackVendorComplianceFlag"
                                id="processTrackVendorComplianceFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processTrackVendorComplianceFlag"
                                id="processTrackVendorComplianceFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="processTrackVendorComplianceFlag"
                                id="processTrackVendorComplianceFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Tracking which vendors provided data is critical for ensuring data reliability. To ensure you are receiving data from an average of 50% of your assisted households, you need to request information from more vendors according to how likely they have been to supply data in the past. If you do not have this information, you will be unable to ensure you will receive data from at least 50% of households.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="processTrackVendorComplianceDesc"
                                  id="processTrackVendorComplianceDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processTrackVendorComplianceDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you track which vendors have supplied requested information in the past  in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="processTrackVendorComplianceDesc"
                                  id="processTrackVendorComplianceDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.processTrackVendorComplianceDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
  
              {state.Assessment4ModelInstance.processTrackVendorComplianceFlag === "Y"
                &&
              <ol className={'lowercaseList'} start={2}>
                  {/*trackVendorDataComplete*/}
                  <li>
                        Does this include tracking whether electric vendors supply complete data (e.g. twelve months of complete billing?
                        <br/>
                        <label>
                            <input type="radio"
                                name="trackVendorDataCompleteFlag"
                                id="trackVendorDataCompleteFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackVendorDataCompleteFlag"
                                id="trackVendorDataCompleteFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="trackVendorDataCompleteFlag"
                                id="trackVendorDataCompleteFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Tracking whether vendors provided <em>complete</em> data is critical for ensuring data reliability. To ensure you are receiving data from an average of 50% of your assisted households, you need to request information from more vendors according to how likely they have been to supply data in the past. In addition, vendors may be mistaken about what constitutes complete data. If a vendor consistently supplies incomplete data, you may need to inform them of exactly what data you need.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="trackVendorDataCompleteDesc"
                                  id="trackVendorDataCompleteDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackVendorDataCompleteDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you track which vendors supplied complete information in the past in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="trackVendorDataCompleteDesc"
                                  id="trackVendorDataCompleteDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.trackVendorDataCompleteDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
                  {state.Assessment4ModelInstance.trackVendorDataCompleteFlag === "Y"
                  &&
                  <li>{/*useTrackingToSelectVendors*/}
                        Do you use this tracking process to determine from which electric vendors to request data on electric expenditures?
                        <br/>
                        <label>
                            <input type="radio"
                                name="useTrackingToSelectVendorsFlag"
                                id="useTrackingToSelectVendorsFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="useTrackingToSelectVendorsFlag"
                                id="useTrackingToSelectVendorsFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="useTrackingToSelectVendorsFlag"
                                id="useTrackingToSelectVendorsFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>
                              This will help you assess whether you are collecting data for enough households to be representative of the entire population of assisted households with each fuel type. Since vendors that supply data should be able to furnish complete records for at least 75% of the LIHEAP households that they serve, make sure you're requesting from enough firms to ensure you will receive data from firms representing at least two thirds of your LIHEAP clients.
                            </span>
                          }
                        {state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              If you don't use your tracking processes to determine from which vendors to request data, then the tracking cannot assist you in ensuring data quality. Since vendors that supply data should be able to furnish complete records for at least 75% of the LIHEAP households that they serve, make sure you're requesting from enough firms to ensure you will receive complete data from firms representing at least two thirds of LIHEAP clients.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="useTrackingToSelectVendorsDesc"
                                  id="useTrackingToSelectVendorsDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.useTrackingToSelectVendorsDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.useTrackingToSelectVendorsFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you use vendor-identification to choose which vendors to request data from in order to complete a full assessment. Your staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="useTrackingToSelectVendorsDesc"
                                  id="useTrackingToSelectVendorsDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.useTrackingToSelectVendorsDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
                  }
              </ol>
              }
          </div>
          }           
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q6ExcludeNot12MoData &&
          <div>
              <p><strong><u>Question 6:</u>&nbsp;&nbsp;Checking for Incomplete Data</strong></p>
              <ol start={6}>
                  {/*excludeHhNot12MonthsData*/}
                  <li>
                        Do you have a check in place to ensure that households are excluded from the dataset if they have some electric baseload data but not a full 12 months?
                        <br/>
                        <label>
                            <input type="radio"
                                name="excludeHhNot12MonthsDataFlag"
                                id="excludeHhNot12MonthsDataFlag_true"
                                value="Y"
                                checked={state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "Y"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="excludeHhNot12MonthsDataFlag"
                                id="excludeHhNot12MonthsDataFlag_false"
                                value="N"
                                checked={state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "N"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="excludeHhNot12MonthsDataFlag"
                                id="excludeHhNot12MonthsDataFlag_dk"
                                value="U"
                                checked={state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "U"}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "Y"
                          && <span>
                              <strong>Good!  </strong>
                              Households with incomplete data will have incorrect values for expenditures, and these will be skewed low, because some of their expenditures are not included. Removing these households from analysis ensures that your estimates of electric expenditures are reliable.
                            </span>
                          }
                        {state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup. </strong>&nbsp;
                              Households with incomplete data will have incorrect values for expenditures, and these will be skewed low, because some of their expenditures are not included. Removing these households from analysis ensures that your estimates of electric expenditures are reliable.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="excludeHhNot12MonthsDataDesc"
                                  id="excludeHhNot12MonthsDataDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.excludeHhNot12MonthsDataDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        {state.Assessment4ModelInstance.excludeHhNot12MonthsDataFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must determine whether you verify that households with incomplete data are excluded from the dataset  in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="excludeHhNot12MonthsDataDesc"
                                  id="excludeHhNot12MonthsDataDesc" style={{width:"100%"}}
                                  value={state.Assessment4ModelInstance.excludeHhNot12MonthsDataDesc}
                                  onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
              </ol>
          </div>
          }           
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q7CheckOutliers &&
          <div>
              <p><strong><u>Question 7:</u>&nbsp;&nbsp;Checking for Outliers</strong></p>
              <ol start={7}>
                  {/*checkAndReportOutliers*/}
                  <li>
                      Do you check the range of electric Baseload fuel bills reported by vendors and investigate the high and low outliers? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkAndReportOutliersFlag"
                              id="checkAndReportOutliersFlag_true"
                              value="Y"
                              checked={state.Assessment4ModelInstance.checkAndReportOutliersFlag === "Y"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAndReportOutliersFlag"
                              id="checkAndReportOutliersFlag_false"
                              value="N"
                              checked={state.Assessment4ModelInstance.checkAndReportOutliersFlag === "N"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAndReportOutliersFlag"
                              id="checkAndReportOutliersFlag_dk"
                              value="U"
                              checked={state.Assessment4ModelInstance.checkAndReportOutliersFlag === "U"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.Assessment4ModelInstance.checkAndReportOutliersFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                            Checking the range of your data and working with vendors to address outliers will help you improve the quality of your data.
                          </span>
                        }
                      {state.Assessment4ModelInstance.checkAndReportOutliersFlag === "N"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            Checking the range of your customer bills and working with vendors to address outliers can improve the quality of your data. If you find some clients with very high values, the vendor may have picked the wrong account or may be including nonresidential uses such as a farm or a store in the same building. If you find some clients with very low values, the vendor may have failed to report on the charges from alternative suppliers or may be reporting on a "secondary" account held by the client.
                            <br/><br/>
                            Please indicate your plans to address this issue in the box below
                            <textarea  name="checkAndReportOutliersDesc"
                                id="checkAndReportOutliersDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.checkAndReportOutliersDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      {state.Assessment4ModelInstance.checkAndReportOutliersFlag === "U"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            You must determine whether you investigate outlying values for electric fuel bills  in order to complete a full assessment. Your IT staff may be able to provide you with this information.
                            <br/><br/>
                            Please indicate your plans for obtaining this information in the box below.
                            <textarea  name="checkAndReportOutliersDesc"
                                id="checkAndReportOutliersDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.checkAndReportOutliersDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      <br/><br/>
                  </li>
              </ol>
          </div>
          }           
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q8ProcessReviewFindings &&
          <div>
              <p><strong><u>Question 8:</u>&nbsp;&nbsp;Taking Action in the Event of Failed Checks</strong></p>
              <ol start={8}>
                  {/*processReviewFindings*/}
                  <li>
                      We have just reviewed the checks you have in place, but you should ask yourself: Are there procedures in place for reviewing and resolving the findings from each check?
                      <br/>
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_true"
                              value="Y"
                              checked={state.Assessment4ModelInstance.processReviewFindingsFlag === "Y"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_false"
                              value="N"
                              checked={state.Assessment4ModelInstance.processReviewFindingsFlag === "N"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_dk"
                              value="U"
                              checked={state.Assessment4ModelInstance.processReviewFindingsFlag === "U"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.Assessment4ModelInstance.processReviewFindingsFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>
                            No action needed!
                          </span>
                      }
                      {state.Assessment4ModelInstance.processReviewFindingsFlag === "N"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            Identifying issues with your data is only half the battle. It is equally important to take action when warnings are triggered. All Grant Recipients should have a system in place for reviewing and taking action in the face of a potential data reliability problem.
                            <br/><br/>
                            Please indicate your plans to address this issue in the box below
                            <textarea  name="processReviewFindingsDesc"
                                id="processReviewFindingsDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processReviewFindingsDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}

                      {state.Assessment4ModelInstance.processReviewFindingsFlag === "U"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            You need to know whether you have procedures for responding to your checks and resolving findings from them in order to perform a complete assessment. Your IT staff may be able to provide you with this information.
                            <br/><br/>
                            Please indicate your plans for obtaining this information in the box below.
                            <textarea  name="processReviewFindingsDesc"
                                id="processReviewFindingsDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processReviewFindingsDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      <br/><br/>
                  </li>
              </ol>
          </div>
          }

          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q9AddingChecks &&
          <div>
              <p><strong><u>Question 9:</u>&nbsp;&nbsp;Adding Checks</strong></p>
              <ol start={9}>
                  {/*processAddChecks*/}
                  <li>
                      Is there a system in place to add checks when new problems arise?
                      <br/>
                      <label>
                          <input type="radio"
                              name="processAddChecksFlag"
                              id="processAddChecksFlag_true"
                              value="Y"
                              checked={state.Assessment4ModelInstance.processAddChecksFlag === "Y"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processAddChecksFlag"
                              id="processAddChecksFlag_false"
                              value="N"
                              checked={state.Assessment4ModelInstance.processAddChecksFlag === "N"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processAddChecksFlag"
                              id="processAddChecksFlag_dk"
                              value="U"
                              checked={state.Assessment4ModelInstance.processAddChecksFlag === "U"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.Assessment4ModelInstance.processAddChecksFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                            No action needed!
                          </span>
                        }

                      {state.Assessment4ModelInstance.processAddChecksFlag === "N"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            The key to having reliable data is ensuring that your system is flexible and ready to adapt to new issues when they arise. All Grant Recipients should have a system in place to add new checks to their data routines in the face of unanticipated problems. 
                            <br/><br/>
                            Please indicate your plans to address this issue in the box below
                            <textarea  name="processAddChecksDesc"
                                id="processAddChecksDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processAddChecksDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      {state.Assessment4ModelInstance.processAddChecksFlag === "U"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            You need to know whether you have a procedure for adding new checks where useful in order to perform a complete assessment. Your IT staff may be able to provide you with this information.
                            <br/><br/>
                            Please indicate your plans for obtaining this information in the box below.
                            <textarea  name="processAddChecksDesc"
                                id="processAddChecksDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processAddChecksDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      <br/><br/>
                  </li>
              </ol>
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.Q10RemovingChecks &&
          <div>
              <p><strong><u>Question 10:</u>&nbsp;&nbsp;Removing/Adjusting Checks</strong></p>
              <ol start={10}>
                  {/*processRemoveChecks*/}
                  <li>
                      Is there a system in place for removing checks that generate high false positive rates?
                      <br/>
                      <label>
                          <input type="radio"
                              name="processRemoveChecksFlag"
                              id="processRemoveChecksFlag_true"
                              value="Y"
                              checked={state.Assessment4ModelInstance.processRemoveChecksFlag === "Y"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processRemoveChecksFlag"
                              id="processRemoveChecksFlag_false"
                              value="N"
                              checked={state.Assessment4ModelInstance.processRemoveChecksFlag === "N"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processRemoveChecksFlag"
                              id="processRemoveChecksFlag_dk"
                              value="U"
                              checked={state.Assessment4ModelInstance.processRemoveChecksFlag === "U"}
                              onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.Assessment4ModelInstance.processRemoveChecksFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                            No action needed!
                          </span>
                        }
                      {state.Assessment4ModelInstance.processRemoveChecksFlag === "N"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            Checks with high false positive rates waste your and your staff's time, as you will need to investigate each warning that check triggers. Grant Recipients should have a system in place for either revising or removing checks that do not function properly.
                            <br/><br/>
                            Please indicate your plans to address this issue in the box below
                            <textarea  name="processRemoveChecksDesc"
                                id="processRemoveChecksDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processRemoveChecksDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      {state.Assessment4ModelInstance.processRemoveChecksFlag === "U"
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                            You need to know whether you have a procedure for removing inefficient checks in order to perform a complete assessment. Your IT staff may be able to provide you with this information.
                            <br/><br/>
                            Please indicate your plans for obtaining this information in the box below.
                            <textarea  name="processRemoveChecksDesc"
                                id="processRemoveChecksDesc" style={{width:"100%"}}
                                value={state.Assessment4ModelInstance.processRemoveChecksDesc}
                                onChange={(changeEvent) => state.assessment4FieldChangeHandler(changeEvent, state.Assessment4ModelInstance)}></textarea>
                          </span>}
                      <br/><br/>
                  </li>
              </ol>
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.ActionPlanSummary &&
          <div>
              <p>
                  <strong><u>Step 11:</u>&nbsp;&nbsp; Aggregated Action Plan </strong>
              </p>

              <p>
                  Congratulations! You have reached the end of Assessment #4. Your
                  aggregated action plan for every issue identified in Assessment
                  #4 is included in the table below. You can now download or print
                  the Assessment #4 action plan below. Also, you can revisit this
                  page at any time by selecting it from the list of completed
                  assessment on the Assessment Tool Selection Page.
              </p>
              <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>


                      {!(state.showActionPlan(state.Assessment4ModelInstance))
                      &&
                      <tbody>
                          <tr>
                              <td colSpan={2}>N/A</td>
                          </tr>
                      </tbody>}

                      {(state.showActionPlan(state.Assessment4ModelInstance))
                      &&
                      <tbody>
                          {(state.Assessment4ModelInstance.trackAcctNoFormatDesc !== '' && state.Assessment4ModelInstance.trackAcctNoFormatDesc !== null)
                          &&
                          <tr>
                            <td>Checking that all account numbers follow the correct format for each vendor.</td>
                            <td>{state.Assessment4ModelInstance.trackAcctNoFormatDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.trackPctHHAcctNoDesc !== '' && state.Assessment4ModelInstance.trackPctHHAcctNoDesc !== null)
                          &&
                          <tr>
                            <td>Tracking the percentage of your assisted households that have an electric vendor and account number listed in their file.</td>
                            <td>{state.Assessment4ModelInstance.trackPctHHAcctNoDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesDesc !== '' && state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesDesc !== null)
                          &&
                          <tr>
                            <td>Tracking the number of assisted households that are missing an electric vendor or account number by agency and vendor. </td>
                            <td>{state.Assessment4ModelInstance.trackMissingAcctNoCertainAgenciesDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.trackPctHHVendorNotFindDesc !== '' && state.Assessment4ModelInstance.trackPctHHVendorNotFindDesc !== null)
                          &&
                          <tr>
                            <td>Tracking the percentage of your assisted households for whom vendors cannot find accounts in the vendor system.</td>
                            <td>{state.Assessment4ModelInstance.trackPctHHVendorNotFindDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.trackNotFindCertainAgenciesDesc !== '' && state.Assessment4ModelInstance.trackNotFindCertainAgenciesDesc !== null)
                          &&
                          <tr>
                            <td>Tracking clients not found in vendor system by agency and vendor.</td>
                            <td>{state.Assessment4ModelInstance.trackNotFindCertainAgenciesDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsDesc !== '' && state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsDesc !== null)
                          &&
                          <tr>
                            <td>Identifying the electric vendors in your state who serve the largest number of clients.</td>
                            <td>{state.Assessment4ModelInstance.processIdentifyLargestElectricVendorsDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatDesc !== '' && state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatDesc !== null)
                          &&
                          <tr>
                            <td>Choosing vendors if the largest main heating suppliers are different than the largest baseload suppliers.</td>
                            <td>{state.Assessment4ModelInstance.processChooseVendorsBaseDiffHeatDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processTrackVendorComplianceDesc !== '' && state.Assessment4ModelInstance.processTrackVendorComplianceDesc !== null)
                          &&
                          <tr>
                            <td>Tracking whether electric vendors have supplied data in the past when requested.</td>
                            <td>{state.Assessment4ModelInstance.processTrackVendorComplianceDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.trackVendorDataCompleteDesc !== '' && state.Assessment4ModelInstance.trackVendorDataCompleteDesc !== null)
                          &&
                          <tr>
                            <td>Tracking whether electric vendors supply complete data (e.g. twelve months of complete billing.</td>
                            <td>{state.Assessment4ModelInstance.trackVendorDataCompleteDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.useTrackingToSelectVendorsDesc !== '' && state.Assessment4ModelInstance.useTrackingToSelectVendorsDesc !== null)
                          &&
                          <tr>
                            <td>Tracking process to determine from which electric vendors to request data on electric expenditures.</td>
                            <td>{state.Assessment4ModelInstance.useTrackingToSelectVendorsDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.excludeHhNot12MonthsDataDesc !== '' && state.Assessment4ModelInstance.excludeHhNot12MonthsDataDesc !== null)
                          &&
                          <tr>
                            <td>Ensure that households are excluded from the dataset if they have some electric baseload data but not a full 12 months.</td>
                            <td>{state.Assessment4ModelInstance.excludeHhNot12MonthsDataDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.checkAndReportOutliersDesc !== '' && state.Assessment4ModelInstance.checkAndReportOutliersDesc !== null)
                          &&
                          <tr>
                            <td>Check the range of electric Baseload fuel bills reported by vendors and investigate the high and low outliers.</td>
                            <td>{state.Assessment4ModelInstance.checkAndReportOutliersDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processReviewFindingsDesc !== '' && state.Assessment4ModelInstance.processReviewFindingsDesc !== null)
                          &&
                          <tr>
                            <td>Procedures in place for reviewing and resolving the findings from each check.</td>
                            <td>{state.Assessment4ModelInstance.processReviewFindingsDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processAddChecksDesc !== '' && state.Assessment4ModelInstance.processAddChecksDesc !== null)
                          &&
                          <tr>
                            <td>System in place to add checks when new problems arise.</td>
                            <td>{state.Assessment4ModelInstance.processAddChecksDesc}</td>
                          </tr>}
                          {(state.Assessment4ModelInstance.processRemoveChecksDesc !== '' && state.Assessment4ModelInstance.processRemoveChecksDesc !== null)
                          &&
                          <tr>
                            <td>System in place for removing checks that generate high false positive rates.</td>
                            <td>{state.Assessment4ModelInstance.processRemoveChecksDesc}</td>
                          </tr>}
                      </tbody>
                      }
                  </table>
          </div>
          }

          <br />
          <button className="dataButton"
              onClick={() => state.assessment4ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment4ShowNextStep()}
                  disabled={state.Assessment4ShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment4ShowActionPlan()}
                  disabled={state.Assessment4ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment4StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment4StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment4StepsEnum.ActionPlanSummary
          &&
            <Assessment4DownloadCSV model={state.Assessment4ModelInstance} />
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment4;
